import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Tooltip } from "src/common/components/Tooltip";
import { useFormatName } from "src/common/hooks/useFormatName";
import { useKnownUsers } from "src/features/auth";
import { PatientLink } from "src/features/patient";
import { useKidneyDiseaseEthiology } from "src/modules/ktx/header/hooks/useKidneyDiseaseEthiology";
import { messages as ktxHeaderMessages } from "src/modules/ktx/header/messages";
import { HeaderValue, renderTitle } from "src/modules/shared/header";

import "./Header.css";

export const KidneyDiseaseEthiology: React.FunctionComponent = () => {
	const users = useKnownUsers();

	const { value, timestamp, origin } = useKidneyDiseaseEthiology();
	const initial = value.substring(0, 2);

	const { formatDate } = useIntl();
	const formatName = useFormatName();

	const title = renderTitle({
		users,
		timestamp,
		origin,
		extra: value,
		formatDate,
		formatName
	});

	let content = (
		<>
			<FormattedMessage {...ktxHeaderMessages.kidneyDiseaseEthiology} />
			{": "}
			{initial}
		</>
	);

	if (origin !== undefined) {
		content = (
			<PatientLink to={`/form/${origin.kind}/${origin.id}`}>
				{content}
			</PatientLink>
		);
	}

	return (
		<Tooltip
			title={title}
			content={<HeaderValue variant="k_d_e">{content}</HeaderValue>}
		/>
	);
};
